let _liveMessage = [];

export default {
    state: {
        showLogin: false,

        alarmMsg: 0,
        alarmNotice: 0,

        messageList: [],
        liveMessage: [],
    },
    mutations: {
        setShowLogin(state, params) {
            state.showLogin = params;
        },
        setAlarmMsg(state, params) {
            state.alarmMsg = params;
        },
        setAlarmNotice(state, params) {
            state.alarmNotice = params;
        },
        setMessageList(state, params) {
          console.log(state,'-----------state',params,'------------params');
            state.messageList = params;
        },
        setLiveMessage(state, params) {
            _liveMessage.push(params);
            state.liveMessage = _liveMessage;
        },
        clearLiveMessage(state) {
            state.liveMessage = [];
        },
    },
    actions: {
        messageListAction({ state, commit }, params) {
            let temp = state.messageList.concat(params);
            commit("setMessageList", temp);
        },
    },
};
